import * as React from "react";
import { forwardRef } from "react";
const SvgTabNotes = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 0v16h11.2l.227-.2 4.373-4.368.2-.232V0zm1.455 1.455h13.09v8.727h-4.363v4.364H1.455Zm10.181 10.181H13.5L11.636 13.5Z", className: "sffee63eef7ab6b96e7234d8c5d74fb3b__b" }));
const ForwardRef = forwardRef(SvgTabNotes);
export { ForwardRef as ReactComponent };
